import React from "react";
import { useHistory, useParams } from "react-router-dom";
import AccessToken from "./AccessToken";
import DeleteComponent from "./DeleteComponent";
import MainSection from "./MainSection";
import API from "@/api/serverCall";
import { applicationDetailInfoType } from "types/app";
import { FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useSelector } from "react-redux";
import { getApplicationInfo } from "@/redux/organization/selector";
import { useTranslation } from "react-i18next";

const initApplicationDetailInfo = {
	app: {
		appToken: "",
		companyToken: "",
		createdAt: "",
		id: 0,
		name: "",
		nextPaymentAt: "",
		packageAndroid: "",
		packageIos: "",
	},
	currentCount: 0,
	totalCount: 0,
	updatedAt: "",
};

function ApplicationSetting() {
	const { id } = useParams<{ id?: string }>();
	const history = useHistory();
	const { t } = useTranslation();
	const applicationList = useSelector(getApplicationInfo);
	const [ApplicationDetailInfo, setApplicationDetailInfo] =
		React.useState<applicationDetailInfoType>(initApplicationDetailInfo);

	const getApplicationDetailInfo = (id: string) => {
		// loading
		try {
			API.GET<applicationDetailInfoType>({
				link: `/app/${id}`,
			}).then((response) => {
				setApplicationDetailInfo(response.data);
			});
		} catch (error) {
			console.error(error);
		}
	};
	React.useEffect(() => {
		if (id) {
			getApplicationDetailInfo(id);
		}
	}, [id]);

	const handleApplicationChange = (e: SelectChangeEvent) => {
		history.push(`/application/${e.target.value}/setting`);
	};

	return (
		<div style={{ flexGrow: 1 }}>
			<section>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "1rem",
						margin: "2rem 2rem",
					}}
				>
					<div style={{ fontSize: "1.5rem", fontWeight: 700 }}>
						Application List
					</div>
					<FormControl>
						<Select value={id} onChange={handleApplicationChange}>
							{applicationList?.map((app) => {
								return <MenuItem value={app.id}>{app.name}</MenuItem>;
							})}
						</Select>
					</FormControl>
				</div>
			</section>
			<section>
				<MainSection
					ApplicationDetailInfo={ApplicationDetailInfo}
					setApplicationDetailInfo={setApplicationDetailInfo}
					translationObject={t}
				/>
			</section>
			<section>
				<AccessToken
					appObject={ApplicationDetailInfo.app}
					translationObject={t}
				/>
			</section>
			<section>
				<DeleteComponent
					appObject={ApplicationDetailInfo.app}
					translationObject={t}
				/>
			</section>
		</div>
	);
}

export default ApplicationSetting;
